var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.22944 19.7702C0.377657 19.9184 0.574703 20 0.784265 20C0.993828 20 1.19088 19.9184 1.33909 19.7702L10 11.1094L18.6609 19.7702C18.8091 19.9184 19.0062 20 19.2157 20C19.4253 20 19.6223 19.9184 19.7706 19.7702C20.0765 19.4643 20.0765 18.9665 19.7706 18.6606L11.1097 9.99981L19.7706 1.33902C20.0765 1.03311 20.0765 0.535346 19.7706 0.229419C19.4646 -0.0764728 18.9668 -0.0764728 18.6609 0.229419L10 8.89017L1.33909 0.229419C1.03317 -0.0764728 0.535359 -0.0764728 0.22944 0.229419C-0.0764799 0.535346 -0.0764799 1.03311 0.22944 1.33902L8.89035 9.99981L0.22944 18.6606C-0.0764799 18.9665 -0.0764799 19.4643 0.22944 19.7702Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5acc6cf74ea9fd3414d43232acaf9d85.svg";
export { ForwardRef as ReactComponent };